export * from "./tabs-container";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/containers/index.ts